import { request } from "./client";
import type { TimeEventInput, TimeEventResponse } from "./types";

/** POST /api/v1/tawa/attendance — record clock-in or clock-out. event_type must be 'attendance_in' | 'attendance_out'. */
export async function recordAttendance(
  body: TimeEventInput,
): Promise<TimeEventResponse> {
  return request<TimeEventResponse>({
    method: "POST",
    url: "/attendance",
    data: body,
  });
}
